import React from 'react';
import classnames from 'classnames';
import styles from './invalidDRMLinkMessage.module.scss';
import ErrorIcon from 'v2/icons/error_warning.svg';

const InvalidDRMLinkMessage = () => {
  return (
    <div
      role="alert"
      className={classnames('d-flex flex-column', styles.container)}
    >
      <div className={classnames('d-flex', styles.check)}>
        <div className={styles.icon}>
          <img src={ErrorIcon} alt={'Error alert icon'}></img>
        </div>
        <div className="d-flex flex-column" data-testid="invalidMessage">
          <span className={classnames(styles.title)}>
            This link is invalid!
          </span>
          <span>
            Either you don’t have permissions to view this entity or the link is
            bad. Please contact whoever sent this to you.
          </span>
        </div>
      </div>
    </div>
  );
};

export default InvalidDRMLinkMessage;
